// Lib
import { Capacitor } from '@capacitor/core';

import { registerMobilePushSubscription } from './mobileNotificationsService';
import { manuallyReportError } from '../../analytics/rollbarService';
import { PushNotificationData, PushNotificationsPlugin } from '../../../capacitor_plugins/pushNotifications';

import { CAPACITOR_PUSH_NOTIFICATIONS_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { PUSH_NOTIFICATION_SUBSCRIPTION_TYPES } from '../../../common/notifications/pushNotificationConstants';

const getPushNotificationSubscriptionType = (platform: string) => {
    switch (platform) {
        case 'ios':
            return PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.APNS;
        case 'android':
            return PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.FCM;
        default:
            return PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.WEB;
    }
};

export const askPushNotificationsPermissionsIfNeeded = async () => {
    if (!Capacitor.isPluginAvailable('PushNotifications')) return;

    PushNotificationsPlugin.requestPermissionsIfNeeded();
};

export const addListenerForPushNotificationRegistration = async () => {
    if (!Capacitor.isPluginAvailable(CAPACITOR_PUSH_NOTIFICATIONS_PLUGIN)) return;

    await PushNotificationsPlugin.addListener('registerToken', async (data: PushNotificationData) => {
        const capacitorPlatform = Capacitor.getPlatform();
        const pushNotificationSubscriptionType = getPushNotificationSubscriptionType(capacitorPlatform);

        try {
            await registerMobilePushSubscription(data.token, pushNotificationSubscriptionType);
            PushNotificationsPlugin.registrationSuccessful();
        } catch (err) {
            manuallyReportError({
                errorMessage: 'Failed to register for push notifications',
                error: err,
            });
        }
    });
};

export const addListenerToTriggerNotificationRegistrationFlow = async () => {
    if (!Capacitor.isPluginAvailable(CAPACITOR_PUSH_NOTIFICATIONS_PLUGIN)) return;

    await PushNotificationsPlugin.addListener('triggerRegistrationFlow', () => {
        PushNotificationsPlugin.registerOnDevice();
    });
};
